import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { getEmployeesOfShiftByCompany } from "../actions/shiftActions";

import { Dialog, DialogTitle } from "@material-ui/core";

import DataList from "../components/DataList";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class ShiftEmployeesOfCompanyList extends Component {
  state = {
    employees: [],

    isDialogOpen: false,
    dialogPhoto: "",
  };

  componentDidMount() {
    this.props
      .getEmployeesOfShiftByCompany(this.props.shiftId, this.props.companyEmail)
      .then((employees) => this.setState({ employees }));
  }

  render() {
    return (
      <Fragment>
        <DataList
          data={this.state.employees.map((employee, i) => {
            return {
              id: i,
              avatar: new Buffer(employee.facePhoto, "base64").toString(
                "binary",
              ),
              title: `${employee.firstName} ${employee.lastName}`,
              subtitle: `Pasnummer: ${employee.companies[0].cardNumber}`,
              onClick: () =>
                this.setState({
                  isDialogOpen: true,
                  dialogPhoto: credentials.user.isAdmin
                    ? new Buffer(
                        employee.companies[0].cardPhoto,
                        "base64",
                      ).toString("binary")
                    : new Buffer(employee.facePhoto, "base64").toString(
                        "binary",
                      ),
                }),
            };
          })}
          isFetching={this.props.isFetching}
          errorMessage={this.props.errorMessage}
        />

        <Dialog
          open={this.state.isDialogOpen}
          onClose={() => this.setState({ isDialogOpen: false })}
        >
          <DialogTitle id="dialog-employeecard">Medewerkerspas</DialogTitle>
          <img
            src={this.state.dialogPhoto}
            style={{ maxWidth: "100%", margin: "10px" }}
          />
        </Dialog>
      </Fragment>
    );
  }
}

ShiftEmployeesOfCompanyList.propTypes = {
  shiftId: PropTypes.string.isRequired,
  companyEmail: PropTypes.string.isRequired,
  getEmployeesOfShiftByCompany: PropTypes.func.isRequired,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  errorMessage: state.shift.getEmployeesOfShiftByCompany.errorMessage,
  isFetching: state.shift.getEmployeesOfShiftByCompany.isFetching,
});

export default connect(mapStateToProps, { getEmployeesOfShiftByCompany })(
  ShiftEmployeesOfCompanyList,
);



// WEBPACK FOOTER //
// ./src/components/ShiftEmployeesOfCompanyList.js